export const validSpecies = [
  "LOAS DEF",
  "LOAS IDOSO",
  "AUX. DOENÇA",
  "AUX. BRASIL",
  "PENSÃO POR MORTE",
  "AUX. DOENÇA POR ACIDENTE DO TRABALHO",
  "AUX. ACIDENTE",
];
